export default "__VITE_ASSET__DuVcec3V__"